export default function Switch({
    checked,
    onChange,
    label,
    disabled = false,
    name,
    className = "",
}) {
    return (
        <label
            className={`inline-flex items-center gap-2 ${disabled ? "cursor-not-allowed opacity-50" : "cursor-pointer"
                } ${className}`}
        >
            {label && <span className="text-xs text-gray-500">{label}</span>}
            <input
                type="checkbox"
                name={name}
                checked={checked}
                onChange={(event) => onChange(event.target.checked)}
                disabled={disabled}
                className="peer sr-only"
            />

            <span
                className="
                    relative h-4 w-7 shrink-0 rounded-full bg-gray-300
                    transition-colors
                    peer-checked:bg-black
                    peer-focus-visible:ring-2
                    peer-focus-visible:ring-black
                    peer-focus-visible:ring-offset-2
                    after:absolute
                    after:left-0.5
                    after:top-0.5
                    after:h-3
                    after:w-3
                    after:rounded-full
                    after:bg-white
                    after:transition-transform
                    after:content-['']
                    peer-checked:after:translate-x-3
                "
            />

            
        </label>
    );
}